import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["trigger"];
import React from 'react';
import { Modal } from 'semantic-ui-react';
import CheckoutBody from './components/CheckoutBody';
import { CartPropType } from '../../services/proptypes';
import './OloCheckout.css';
var OloCheckout = function OloCheckout(_ref) {
  var trigger = _ref.trigger,
    checkoutBodyProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Modal, {
    className: "checkout-modal",
    trigger: trigger,
    dimmer: "inverted"
  }, /*#__PURE__*/React.createElement(Modal.Header, null, "Checkout"), /*#__PURE__*/React.createElement(Modal.Content, null, /*#__PURE__*/React.createElement(CheckoutBody, checkoutBodyProps)));
};
export default OloCheckout;